<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100 pl-4"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="isOpen" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6 justify-space-between">
          <div class="titlePanel primary--text">
            {{ $t('income.cashClosings.drawerDetails.title') }} - {{  $moment(cashClosing.cashCloseDate).format('dddd') }} {{ $moment(cashClosing.cashCloseDate).format('DD-MM-YYYY') }}
          </div>
          <div v-if="cashClosePermissions['update-cashClose']">
            <v-tooltip
              max-width="200"
              left>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  fab
                  x-small
                  v-on="on"
                  color="secondary"
                  class="close mr-3"
                  @click="refresCashClose"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>
                Actualizar corte
              </span>
            </v-tooltip>
          </div>
        </div>

        <div>
          <table class="tableNetSale">
            <thead>
              <tr>
                <th></th>
                <th>{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.subtotal') }}</th>
                <th>{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.tax') }}</th>
                <th>{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.total') }}</th>
              </tr>
            </thead>
            <tbody class="amountBox">
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.grossSale') }}</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ (cashClosing.grossSale + cashClosing.discount + cashClosing.cancellations) | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.netSales') }}</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ cashClosing.grossSale | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Descuentos</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ cashClosing.discount | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Cancelaciones</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ cashClosing.cancellations | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Cortesias</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ cashClosing.courtesy | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Anulaciones</td>
                <td></td>
                <td></td>
                <td class="text-right">{{ cashClosing.annulments | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableNetSale.headers.netSale') }}</td>
                <td class="text-right">{{ cashClosing.subtotal | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td class="text-right">{{ cashClosing.iva | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td class="text-right">{{ cashClosing.netSystemSale | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="mb-4">
          <table class="tableCash">
            <thead>
              <tr>
                <th></th>
                <th class="font-weight-regular header">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.tips') }}</th>
                <th class="font-weight-regular header">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.sale') }}</th>
                <th class="font-weight-regular header">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.total') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.netCash') }}</td>
                <td></td>
                <td class="text-right">{{ cashClosing.cashSystemSale | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
              </tr>
              <tr v-if="!hasData" style="display: none;"></tr>
              <tr v-else v-for="incomeType in cashClosing.payments" :key="incomeType.field" :class="updatePaymentsTipOn[incomeType.field] && 'updateActiveRow'">
                <td>{{ incomeType.name }}</td>
                <td v-if="isDefinitiveClosed" class="text-right">
                  {{ incomeType.tip | toFixNumber(2) | numberWithComma | prefix('$') }}
                </td>
                <td v-else>
                  <div class="d-flex align-center justify-end">
                    <span>{{ incomeType.tip ? formatCurrency(incomeType.tip) : '--------' }}</span>
                    <v-btn
                      v-if="incomeType.editableTip"
                      icon
                      color="primary"
                      x-small
                      @click="openTipDialog(incomeType)"
                      class="ml-1"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td v-if="isDefinitiveClosed" class="text-right">{{ incomeType.amount ? formatCurrency(incomeType.amount) : undefined }}</td>
                <td>
                  <div class="d-flex align-center justify-end">
                    <span>{{ incomeType.amount ? formatCurrency(incomeType.amount) : '--------' }}</span>
                    <v-btn
                      v-if="!isDefinitiveClosed && cashClosePermissions['edit-amount']"
                      icon
                      color="primary"
                      x-small
                      @click="openAmountDialog(incomeType)"
                      class="ml-1"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td class="text-right">{{ incomeType.total ? formatCurrency(incomeType.total) : undefined }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.netSale') }}</td>
                <td></td>
                <td class="text-right">
                  <div class="d-flex justify-end">
                    <span>{{ cashClosing.totalNetSystemSale | toFixNumber(2) | numberWithComma | prefix('$') }}</span>
                    <v-tooltip v-if="!totalNetSaleMatches" bottom max-width="440px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="yellow" class="ml-1 alertIcon">mdi-alert</v-icon>
                      </template>
                      <span>{{ $t('income.cashClosings.drawerDetails.tableCash.netSaleTooltip') }}</span>
                    </v-tooltip>
                  </div>
                </td>
                <td></td>
              </tr>
              <tr v-if="hasManualPayment">
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.tipsCheck') }}</td>
                <td class="text-right">{{ cashClosing.byTipTotal | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.tipsCheckHSBC') }}</td>
                <td class="text-right">{{ cashClosing.tipTotal | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableCash.headers.realCash') }}</td>
                <td class="text-right">{{ cashClosing.realCash | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="text-right mb-4" style="width: 100%;" v-if="cashClosePermissions['validate-status']">
          <Button size="x-small"  :disabled="cashClosing.status == 'validated'" @click="updateState">{{ $t('income.cashClosings.drawerDetails.buttonValidate') }}</Button>
        </div>

        <div class="mb-4">
          <table class="tableTotalCash">
            <tbody>
              <tr :class="updateCashCloseUpdatedOn && 'updateActiveRow'">
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableTotalCash.headers.cash') }}</td>
                <td></td>
                <td v-if="isDefinitiveClosed" class="text-right">
                  {{ cashClosing.cashCloseUpdated | toFixNumber(2) | numberWithComma | prefix('$') }}
                </td>
                <td v-else>
                  <div class="d-flex align-center">
                    <v-text-field
                      v-show="updateCashCloseUpdatedOn"
                      v-model.lazy="$v.cashClosingForm.newCashCloseUpdated.$model"
                      type="number"
                      :error-messages="cashCloseUpdatedErrors"
                      @blur="updateCashCloseUpdated()"
                      rounded
                      outlined
                      dense
                      class="mt-7" />
                    <span v-show="!updateCashCloseUpdatedOn">{{ cashClosing.cashCloseUpdated ? formatCurrency(cashClosing.cashCloseUpdated) : '--------' }}</span>
                    <v-btn
                      v-show="!updateCashCloseUpdatedOn"
                      icon
                      color="primary"
                      x-small
                      @click="setUpdateCashCloseUpdatedOn"
                      class="ml-1"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </div>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableTotalCash.headers.cancelations') }}</td>
                <td></td>
                <td class="text-right">{{ cashClosing.cancellationByPlatform | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
              </tr>
              <tr>
                <td class="font-weight-bold">{{ $t('income.cashClosings.drawerDetails.tableTotalCash.headers.total') }}</td>
                <td></td>
                <td class="text-right">{{ cashClosing.totalSaleVerified | toFixNumber(2) | numberWithComma | prefix('$') }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-right" style="width: 100%;" v-if="cashClosePermissions['validate-definitive-status']">
          <Button size="x-large" :disabled="cashClosing.status !== 'validated' || cashClosing.definitiveStatus === 'validated'" @click="openWarningDialog">{{ $t('income.cashClosings.drawerDetails.buttonValidateWithoutCancelations') }}</Button>
        </div>

      </div>
    </v-navigation-drawer>

    <v-dialog @keydown.esc="tipDialogOpen=false" v-model="tipDialogOpen" persistent max-width="296px">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeTipDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="px-6 pb-0 tipTitle">{{ $t('income.cashClosings.drawerDetails.tipDialog.title') }}</v-card-title>
        <v-card-text class="d-flex flex-column align-center">
          <v-text-field
            v-model.lazy="$v.selectedIncomeType.tip.$model"
            type="number"
            :error-messages="paymentsTipErrors"
            rounded
            outlined
            dense
            class="mt-7" />
        </v-card-text>
        <v-card-actions class="px-6 justify-space-between">
          <Button size="xx-small" type="outlined" @click="closeTipDialog()">
            {{ $t('income.cashClosings.drawerDetails.tipDialog.buttonCancel') }}
          </Button>
          <Button size="xx-small" @click="updatePaymentsTip(selectedIncomeType.field)">
            {{ $t('income.cashClosings.drawerDetails.tipDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="amountDialogOpen=false" v-model="amountDialogOpen" persistent max-width="296px">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            small
            depressed
            @click="closeAmountDialog()"
            class="mr-1 mt-1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="px-6 pb-0 tipTitle">{{ $t('income.cashClosings.drawerDetails.amountDialog.title') }}</v-card-title>
        <v-card-text class="d-flex flex-column align-center">
          <v-text-field
            v-model.lazy="$v.selectedAmountIncomeType.amount.$model"
            type="number"
            :error-messages="amountErrors"
            rounded
            outlined
            dense
            class="mt-7" />
        </v-card-text>
        <v-card-actions class="px-6 justify-space-between">
          <Button size="xx-small" type="outlined" @click="closeAmountDialog()">
            {{ $t('income.cashClosings.drawerDetails.amountDialog.buttonCancel') }}
          </Button>
          <Button size="xx-small" @click="updateAmount(selectedAmountIncomeType.field)">
            {{ $t('income.cashClosings.drawerDetails.amountDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="warningDialogOpen=false" v-model="warningDialogOpen" persistent max-width="453px">
      <v-card>
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            depressed
            @click="closeWarningDialog"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="d-flex flex-column align-center">
          <v-icon class="alert-icon">mdi-alert-circle-outline</v-icon>
          <div class="mt-4 text-center">
            <p class="dialogText">{{ $t('income.cashClosings.drawerDetails.warningDialog.text') }}</p>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 justify-space-between">
          <Button size="small" type="outlined" @click="closeWarningDialog">
            {{ $t('income.cashClosings.drawerDetails.warningDialog.buttonCancel') }}
          </Button>
          <Button size="small" @click="createDeposit">
            {{ $t('income.cashClosings.drawerDetails.warningDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <NewDeposit
      ref="newDeposit"
      :amount="cashClosing.cancellationByPlatform"
      :cashCloseDate="cashClosing.cashCloseDate"
      @updateDefinitiveState="updateDefinitiveState"
      />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, decimal, minValue } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'
import Button from '@/components/elements/Button'
import NewDeposit from '@/components/modals/NewDeposit'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'CashClosingDetails',
  props: {
    isOpen: Boolean,
    selectedCashClosing: Object
  },
  components: {
    Button,
    NewDeposit
  },
  emits: ['close', 'update:isOpen', 'updateCashClosings'],
  mixins: [validationMixin],
  validations: {
    cashClosingForm: {
      newCashCloseUpdated: { required, decimal, minValue: minValue(0) }
    },
    selectedIncomeType: {
      tip: { required, decimal }
    },
    selectedAmountIncomeType: {
      amount: { required, decimal }
    }
  },
  data () {
    return {
      overlay: false,
      warningDialogOpen: false,
      tipDialogOpen: false,
      amountDialogOpen: false,
      selectedIncomeType: {
        label: '',
        tip: 0
      },
      selectedAmountIncomeType: {
        label: '',
        amount: 0
      },
      updatePaymentsTipOn: {},
      displayEditButton: [],
      cashClosingForm: {
        newCashCloseUpdated: 0
      },
      updateCashCloseUpdatedOn: false,
      tipsCheckHSBC: {}
    }
  },
  watch: {
    cashClosing: function () {
      if (!isEmpty(this.cashClosing)) {
        this.cashClosingForm.newCashCloseUpdated = this.cashClosing.cashCloseUpdated || 0
      }
    }
  },
  computed: {
    hasManualPayment () {
      if (!this.cashClosing || !this.cashClosing.payments) return false
      return this.cashClosing.payments.some(payment => payment.name === 'MANUAL' || payment.name === 'Manual' || payment.name === 'manual')
    },
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    },
    cashClosing: {
      get: function () {
        return this.selectedCashClosing
      },
      set: function (newValue) {
        this.$emit('update:selectedCashClosing', newValue)
      }
    },
    isDefinitiveClosed: function () {
      return this.cashClosing.definitiveStatus === 'validated'
    },
    hasData: function () {
      return !isEmpty(this.cashClosing.payments)
    },
    cashCloseUpdatedErrors () {
      const errors = []
      if (!this.$v.cashClosingForm.newCashCloseUpdated.$dirty) return errors
      // !this.$v.cashClosingForm.newCashCloseUpdated.minValue && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tableCash.validations.positive'))
      !this.$v.cashClosingForm.newCashCloseUpdated.decimal && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tableCash.validations.number'))
      !this.$v.cashClosingForm.newCashCloseUpdated.required && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tableCash.validations.required'))
      return errors
    },
    paymentsTipErrors () {
      const errors = []
      if (!this.$v.selectedIncomeType.tip.$dirty) return errors
      // !this.$v.selectedIncomeType.tip.minValue && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tipDialog.validations.positive'))
      !this.$v.selectedIncomeType.tip.decimal && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tipDialog.validations.number'))
      !this.$v.selectedIncomeType.tip.required && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.tipDialog.validations.required'))
      return errors
    },
    amountErrors () {
      const errors = []
      if (!this.$v.selectedAmountIncomeType.amount.$dirty) return errors
      !this.$v.selectedAmountIncomeType.amount.decimal && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.amountDialog.validations.number'))
      !this.$v.selectedAmountIncomeType.amount.required && errors.push(this.$i18n.t('income.cashClosings.drawerDetails.amountDialog.validations.required'))
      return errors
    },
    totalNetSaleMatches: function () {
      if (isEmpty(this.cashClosing)) {
        return true
      } else {
        let totalNetSaleSum = 0
        this.cashClosing.payments.forEach(payment => {
          totalNetSaleSum += payment.amount
        })

        return this.cashClosing.totalNetSystemSale === totalNetSaleSum
      }
    },
    cashClosePermissions () {
      return this.$store.state.login.permissions['expenses'].components['cash-close'].actions
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.open = false
      }
    },
    closePanel () {
      this.resetForm()
      this.open = false
    },
    async refresCashClose () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/cashClose/${this.cashClosing._id}/refresh`)
        this.$emit('updateCashClosings')
        this.loadCashClosing()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    loadCashClosing: async function (params = null) {
      params = params || {}
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashClose/${this.cashClosing._id}`, params)
        this.cashClosing = response
        this.$emit('updateCashClosings')
        this.closeWarningDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateCashClosing: async function (payload = {}, field) {
      this.overlay = true
      try {
        await this.$api.put(`/v1/cashClose/${this.cashClosing._id}`, payload) // prod
        // await this.$api.put(`/v1/cashClose/${this.cashClosing._id}?restaurant=${restaurant}`, payload) // dev => comment in prod
        switch (field) {
          case 'status':
            this.$emit('updateCashClosings')
            break
          case 'definitiveStatus':
            this.closeWarningDialog()
            this.$emit('updateCashClosings')
            break
          case 'cashCloseUpdated':
            this.loadCashClosing()
            this.setUpdateCashCloseUpdatedOff()
            break
          default:
            break
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateCashClosingTip: async function (payload = {}) {
      this.overlay = true
      try {
        await this.$api.post(`/v1/cashClose/${this.cashClosing._id}/update-tip`, payload)
        this.loadCashClosing()
        this.closeTipDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateCashClosingAmount: async function (payload = {}) {
      this.overlay = true
      try {
        await this.$api.post(`/v1/cashClose/${this.cashClosing._id}/update-amount`, payload)
        this.loadCashClosing()
        this.closeAmountDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openWarningDialog () {
      this.warningDialogOpen = true
    },
    closeWarningDialog () {
      this.warningDialogOpen = false
    },
    setUpdateCashCloseUpdatedOn () {
      this.updateCashCloseUpdatedOn = true
    },
    setUpdateCashCloseUpdatedOff () {
      this.updateCashCloseUpdatedOn = false
    },
    updatePaymentsTip (paymentTypeField) {
      this.$v.selectedIncomeType.tip.$touch()

      if (!this.$v.selectedIncomeType.tip.$invalid) {
        this.updateCashClosingTip({ field: paymentTypeField, tip: this.selectedIncomeType.tip })
      }
    },
    updateAmount (paymentTypeField) {
      this.$v.selectedAmountIncomeType.amount.$touch()

      if (!this.$v.selectedAmountIncomeType.amount.$invalid) {
        this.updateCashClosingAmount({ field: paymentTypeField, amount: this.selectedAmountIncomeType.amount })
      }
    },
    updateState () {
      this.$v.cashClosingForm.$touch()

      if (!this.$v.cashClosingForm.$invalid) {
        this.updateCashClosing({ status: 'validated' }, 'status')
        this.closePanel()
      }
    },
    updateDefinitiveState () {
      this.$v.cashClosingForm.$touch()

      if (!this.$v.cashClosingForm.$invalid) {
        this.updateCashClosing({ definitiveStatus: 'validated' }, 'definitiveStatus')
        this.closePanel()
      }
    },
    createDeposit () {
      this.openNewDepositDialog()
    },
    updateCashCloseUpdated () {
      this.$v.cashClosingForm.newCashCloseUpdated.$touch()

      if (!this.$v.cashClosingForm.newCashCloseUpdated.$invalid) {
        this.updateCashClosing({ cashCloseUpdated: this.cashClosingForm.newCashCloseUpdated }, 'cashCloseUpdated')
      }
    },
    resetForm () {
      this.$v.$reset()
    },
    openTipDialog (item) {
      this.selectedIncomeType = Object.assign(this.selectedIncomeType, item)
      this.tipDialogOpen = true
    },
    closeTipDialog () {
      this.tipDialogOpen = false
    },
    openAmountDialog (item) {
      this.selectedAmountIncomeType = Object.assign(this.selectedAmountIncomeType, item)
      this.amountDialogOpen = true
    },
    closeAmountDialog () {
      this.amountDialogOpen = false
    },
    formatCurrency,
    openNewDepositDialog () {
      this.$refs.newDeposit.open()
    }
  }
}

</script>

<style lang="scss" scoped>
  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .tableNetSale {
    width: 100%;
    border-spacing: 12px;
    border-collapse: collapse;

    & td {
      padding: 6px 35px;
    }
  }

  .amountBox {
    background: #F0F0F0;
    border: 1.5px dashed #757575;
  }

  .tableCash {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;

    .header {
      font-size: 1.143rem;
    }

    & tr {
      & th {
        padding: 22px 18px;
        background-color: #fff;
      }

      & td {
        padding: 22px 18px;
        background-color: #fff;
        border-top: 1px solid #ACABAB;
        border-bottom: 1px solid #ACABAB;

        &:first-child {
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
          border-left: 1px solid #ACABAB;
        }

        &:last-child {
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          border-right: 1px solid #ACABAB;
        }
      }
    }

    & tfoot tr {
      & td {
        background-color: #f9f9f9;
      }
    }
  }

  .tableTotalCash {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px;

    & tr {
      &:nth-child(odd) td {
        background-color: #f9f9f9;
      }
      &:nth-child(even) td {
        background-color: #EDEDED;
      }
      & td {
        padding: 22px 18px;

        &:first-child {
          border-top-left-radius: 7px;
          border-bottom-left-radius: 7px;
        }

        &:last-child {
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
        }
      }
    }
  }

  .alert-icon {
    font-size: 6.25rem !important;
    color: #DF2D2D !important;
  }

  .dialogText {
    font-size: 1.285rem;
    line-height: 1.25;
    margin-bottom: 0;
    font-size: 1.125rem;
    line-height: 24.24px;
  }

  .updateActiveRow {
    & td {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }

  .tipTitle {
    color: #01D28E;
    font-size: 1.375rem;
  }

  .alertIcon {
    font-size: 20px;
  }
</style>

<style lang="scss">
  .v-dialog > .v-card > .v-card__actions {
    padding: 0 16px 24px;
  }
</style>
